import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Storage from "../core/config/Storage";
import { useStore } from "vuex";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/play/:p/:c",
    name: "play",
    component: () => import("@/components/Play.vue"),
  },
  {
    path: "/:pathMath(.*)*",
    name: "not-found",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "/error/:t/",
    name: "error",
    component: () => import("@/components/Error.vue"),
  },
  {
    path: "/",
    name: "layout",
    component: () => import("@/components/Layout.vue"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/style1/HomeView.vue"),
      },
      {
        path: "/:provider",
        name: "lobby",
        component: () => import("@/views/style1/Lobby.vue"),
        beforeEnter: async (to, from, next) => {
          const store = useStore();
          const providersList = store.getters["providers/getList"];
          if (providersList.data.length !== 0) {
            const providerExists = providersList.data.some(
              (providerData: any) => providerData.game === to.params.provider
            );
            if (providerExists) {
              next();
              return;
            } else {
              next({ name: "not-found" });
            }
          } else {
            next({ name: "not-found" });
          }
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/style1/Login.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = await Storage.checkToken();

  const lToken = to.query.ltoken;
  if (lToken !== null && lToken !== undefined) {
    await Storage.setlToken(lToken.toString());
    const now = new Date();
    const expirationTime = now.getTime() + 6 * 60 * 60 * 1000;
    localStorage.setItem("expirationTime", expirationTime.toString());
    next({ name: "home" });
  } else if (
    to.name !== "not-found" &&
    to.name !== "login" &&
    to.name !== "error" &&
    !isAuthenticated
  ) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
